module.exports = __webpack_public_path__ + "img/icon_pintu_232.6306ec7a.png";